import LocationService from "pro-features/components/Modals/src/UnlockModal/LocationService";
import trackingService from "../tracking/trackingService";
import HooksModalV5Key from "app/constants/HooksModalV5Key";
import { handleCTAClick, TestCases } from "app/common/utils/handleGainAccessRedirect";
import { EHooksVersions } from "app/services/SwHook";

export const openRevealHookModal = (): void => {
    trackingService.trackFeatureAccessRequested();
    handleCTAClick(
        EHooksVersions.V5,
        HooksModalV5Key.SalesSolutionRevealDefault,
        TestCases.TRIAL_AFTER_TRIAL,
        `${LocationService.getCurrentLocationTracking()}`,
    );
};
